import { useEffect } from "react";
import { gsap } from "gsap";

interface ScaleYAnimationProps {
    svgElement: SVGElement;
    scaleAngle: number,
    animationSpeed: number;
  }

  const ScaleYAnimation: React.FC<ScaleYAnimationProps> = ({
    svgElement,
    scaleAngle = 10,
    animationSpeed = 1,
  }) => {
    useEffect(() => {
      gsap.to(svgElement, {
        scaleY: scaleAngle,
        duration: animationSpeed,
        ease: "power1.inOut",
        repeat: -1,
        yoyo: true,
      });
    }, [svgElement, scaleAngle, animationSpeed]);
  
    return null;
  };
   
export default ScaleYAnimation;
